/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_FailedInputs */

const en_portalsignin_passkey_failed = /** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That passkey did not work`)
};

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const ar_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const he_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const ur_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const es_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const fr_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const de_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const pt_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const hi_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/** @type {(inputs: Portalsignin_Passkey_FailedInputs) => LocalizedString} */
const bn_portalsignin_passkey_failed = en_portalsignin_passkey_failed;

/**
* | output |
* | --- |
* | "That passkey did not work" |
*
* @param {Portalsignin_Passkey_FailedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_failed = /** @type {((inputs?: Portalsignin_Passkey_FailedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_FailedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_passkey_failed(inputs)
	if (locale === "he") return he_portalsignin_passkey_failed(inputs)
	if (locale === "ur") return ur_portalsignin_passkey_failed(inputs)
	if (locale === "es") return es_portalsignin_passkey_failed(inputs)
	if (locale === "fr") return fr_portalsignin_passkey_failed(inputs)
	if (locale === "de") return de_portalsignin_passkey_failed(inputs)
	if (locale === "pt") return pt_portalsignin_passkey_failed(inputs)
	if (locale === "hi") return hi_portalsignin_passkey_failed(inputs)
	if (locale === "bn") return bn_portalsignin_passkey_failed(inputs)
	return /** @type {LocalizedString} */ ("That passkey did not work")
});